import { PkButton } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useEffect } from 'react';

import { useUefatvOptions } from '@apps/uefa-tv/store';
import { clearStoredTokens } from '@core/uefatvClient/repository';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const ErrorPage = () => {
  const { options } = useUefatvOptions();
  const t = useTranslateFn();
  const getRedirectLink = () => {
    return options?.errorRedirectUrl ?? `/${window.competitionUrl}/`;
  };

  useEffect(() => {
    clearStoredTokens();
  }, []);

  return (
    <div className={clsx(styles.bg)}>
      <div className={clsx('pk-container', styles.container)}>
        <div className={clsx('pk-col pk-col--span-12 pk-col--mobile-full-width pk-gap--l')}>
          <p className='pk-text--center pk-text--text-01 pk-font--base-semibold'>{t('something_went_wrong')}</p>
          <PkButton linkHref={getRedirectLink()} linkRel='_self' type='button'>
            {t('back_to_home_page')}
          </PkButton>
        </div>
      </div>
      <div className={clsx(styles.image)} />
    </div>
  );
};
export default memo(ErrorPage);
